import { Grid, GridProps } from "@mui/material";
import { forwardRef } from "react";

type AuthenticationContentProps = Omit<GridProps, "container">;

const AuthenticationContent = forwardRef<HTMLDivElement, AuthenticationContentProps>(
  ({ sx, ...props }, ref) => {
    return (
      <Grid
        container
        ref={ref}
        sx={{
          maxWidth: {
            xs: "400px",
            lg: "475px",
          },
          ...sx,
        }}
        {...props}
      />
    );
  }
);

export default AuthenticationContent;
